import ResidentBtn from './ResidentBtn';

export default ResidentBtn;
